import { Link } from '@tanstack/react-router';
import imgUrl from '@/assets/logo.svg';
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';

type Props = {
  plan: string | undefined;
};

export function NavHeader({ plan }: Props) {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton size="lg" asChild>
          <Link to="/">
            <div className="bg-white text-sidebar-primary-foreground flex aspect-square size-8 items-center justify-center rounded-md p-0.5">
              <img src={imgUrl} />
            </div>
            <div className="grid flex-1 text-left text-sm leading-tight">
              <span className="truncate font-medium">FeatureBuddy</span>
              {plan && (
                <span className="truncate text-xs font-medium text-green-600 dark:text-green-400">
                  {plan} Plan
                </span>
              )}
            </div>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
